/*
 * @Author: zyy
 * @Date: 2022-11-11 17:46:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-09-06 17:14:00
 * @Description: default
 */
export const TJListMixin = {
    data() {
        return {
            service: undefined,
            showEdit: false,
            labelCol: { span: 3 },
            wrapperCol: { span: 18 },
            table: {
                data: [],
                loading: false
            },
            ipagination: {
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['2', '5', '10', '20', '30'],
                showTotal: (total, range) => {
                    return range[0] + "-" + range[1] + " 共" + total + "条"
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 0
            },
            loading: false,
            searchQuery: {
                page: 1,
                per_page: 10
            },
            modal: {
                show: false,
                loading: false
            },
        }
    },
    activated() {
        this.getList()
    },
    methods: {
        getList() {
            if (!this.service) return
            this.table.loading = true;
            const { current, pageSize } = this.ipagination;
            this.service?.list({
                page: current,
                limit: pageSize,
                ...this.searchQuery
            }).then(res => {
                this.table.data = res.data
                this.ipagination.total = res.meta.pagination.total
                this.table.loading = false
            })

        },
        handleOpen(data) {
            this.showEdit = true
            this.$nextTick(() => {
                this.$refs.editRef.open(data)
            })

        },
        handleDelete(data) {
            this.$confirm({
                title: '提示',
                content: '确认删除？',
                onOk: async () => {
                    await this.service.del(data)
                    this.getList()
                    this.$message.success('删除成功')
                }
            })

        },

        // 新分页
        handlePageChange(page) {
            this.ipagination.current = page.current;
            this.ipagination.pageSize = page.pageSize;

            this.searchQuery.page = page.current
            this.searchQuery.per_page = page.pageSize
            this.getList()
        },
        toSearch() {
            this.searchQuery.page = 1
            this.getList()
        },
        searchReset() {
            this.searchQuery = {
                page: 1,
                per_page: 10
            }
            this.getList()
        },
    }

}

